import React from 'react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-161">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[150px] pointer-events-none" data-id="element-162"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-cta-green/10 rounded-full blur-[100px] pointer-events-none" data-id="element-163"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-164">
        <h2 className="text-3xl sm:text-6xl font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight drop-shadow-lg" data-id="element-165">
          La Oferta Redonda
        </h2>

        {/* Featured Card */}
        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-primary/50 shadow-[0_0_50px_rgba(59,130,246,0.15)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto backdrop-blur-xl" data-id="element-166">
          {/* Glowing Border Effect */}
          <div className="absolute inset-0 rounded-xl sm:rounded-3xl border-2 border-transparent bg-gradient-to-b from-primary/50 to-transparent opacity-50 pointer-events-none" style={{
          maskImage: 'linear-gradient(to bottom, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent)'
        }} data-id="element-167"></div>

          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(245,158,11,0.5)] border border-white/20" data-id="element-168">
            ⭐ MÁS ELEGIDO
          </div>

          <p className="text-sm sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-169">
            TODO ESTO POR SEPARADO:
          </p>

          {/* Compact list on mobile */}
          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-170">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-171">
              <span data-id="element-172">MegaPack Pilates (6 Tomos)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-173">
                $97
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-174">
              <span data-id="element-175">Manual de Especialista Postural</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-176">
                $57
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-177">
              <span data-id="element-178">6 Bonos Estratégicos de Gestión</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-179">
                $39
              </span>
            </div>
            <div className="flex justify-between text-text-main font-black pt-1 sm:pt-4 text-base sm:text-2xl" data-id="element-180">
              <span data-id="element-181">TOTAL:</span>
              <span className="text-badge-red line-through" data-id="element-182">US$ 193</span>
            </div>
          </div>

          {/* Price reveal — ultra compact on mobile */}
          <div className="text-center mb-3 sm:mb-10 bg-gradient-to-b from-primary/10 to-transparent border border-primary/20 py-3 sm:py-8 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-183">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-184"></div>
            <p className="text-primary font-bold mb-1 sm:mb-4 text-xs sm:text-lg" data-id="element-185">
              Oferta de Lanzamiento:
            </p>
            <div className="text-text-main font-black text-3xl sm:text-7xl tracking-tighter drop-shadow-2xl" data-id="element-186">
              🏆 USD 19.90
            </div>
            <div className="text-text-sec text-[10px] sm:text-base font-medium mt-0.5" data-id="element-187">
              (En tu moneda local)
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/20 animate-pulse mx-auto mb-3 sm:mb-6" data-id="element-188">
            ⏰ Precio de lanzamiento — sube pronto
          </span>

          <a href="https://docentes2.edulabs.online/cart/43326617419894:1" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Combo Elite Pilates',
              content_type: 'product',
              value: 19.9,
              currency: 'USD'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black text-base sm:text-2xl py-3.5 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_0_40px_rgba(16,185,129,0.4)] border border-white/20 mb-2 sm:mb-6" data-id="element-189">
            🚀 ¡SÍ! QUIERO EL COMBO ELITE
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-8 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-190">
            <span data-id="element-191">⚡ Acceso Inmediato</span>
            <span data-id="element-192">•</span>
            <span data-id="element-193">💳 Un solo Pago</span>
            <span data-id="element-194">•</span>
            <span data-id="element-195">🛡️ Garantía 7 Días</span>
          </p>
        </div>
      </div>
    </section>;
}